// extracted by mini-css-extract-plugin
export default {"Back":"Back_Back__o3bDr","button":"Back_button__xZtWi"};